export function normalizarTextoMayusculasSinTildes(valor: string | null | undefined): string {
  return (valor ?? '')
    .normalize('NFC')
    .replace(/ñ/g, '\uE000')
    .replace(/Ñ/g, '\uE001')
    .replace(/ü/g, '\uE002')
    .replace(/Ü/g, '\uE003')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .replace(/\uE000|\uE001/g, 'Ñ')
    .replace(/\uE002|\uE003/g, 'Ü')
    .trim();
}
